import React from 'react';
import { graphql } from 'gatsby';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import Layout from '../../components/Layout';
import PageHeader from '../../components/PageHeader';
import ModularBlocks from '../../components/ModularBlocks';
import ContactForm from '../../components/ContactForm';
import CompanyReviews from '../../components/CompanyReviews';
import { getSchemaDescription, getServiceSchemaData } from '../../utils';

const ServicePageTemplate = ({
  data: {
    datoCmsService: { seoMetaTags, title, modularBlocks, serviceSchema },
    datoCmsPlantsForBusiness: { sitewideNotices },
  },
}) => {
  const serviceData = getServiceSchemaData({
    serviceSchema,
    seoMetaTags,
    title,
  });

  return (
    <Layout
      title={title}
      description={getSchemaDescription(seoMetaTags)}
      service={serviceData}
      sitewideNotices={sitewideNotices}
    >
      <HelmetDatoCms seo={seoMetaTags} />
      <main>
        <PageHeader
          heading={title}
          breadcrumbs={[
            { slug: 'plants-for-business', text: 'Plants for Business' },
          ]}
        />
        <ModularBlocks items={modularBlocks} />
      </main>
      <ContactForm />
      <CompanyReviews />
    </Layout>
  );
};

export const ServicePageTemplateQuery = graphql`
  query ServicePageTemplateQuery($id: String!) {
    datoCmsService(id: { eq: $id }) {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      title
      modularBlocks {
        ...ContainedImageModularBlockFragment
        ...ContentModularBlockFragment
        ...ExternalVideoModularBlockFragment
        ...FullWidthImageModularBlockFragment
        ...HighlightedTextModularBlockFragment
        ...ImageContentModularBlockFragment
        ...ImageGalleryModularBlockFragment
        ...InternalVideoModularBlockFragment
      }
      serviceSchema {
        serviceType
        serviceAreaServed
      }
    }
    datoCmsPlantsForBusiness {
      sitewideNotices {
        text
      }
    }
  }
`;

export default ServicePageTemplate;
